import { Dashboard } from 'app/area/dashboard/dashboard';
import { STATE } from 'app/constants';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import { scrollToTop } from 'app/infrastructure/platform/routing';
import * as React from 'react';

import { startupTranslation } from './constants';
import { StartupState } from './types-store';
import { NewCaseBanner } from 'app/area/startup/components/new-case-banner';
import { LinksSection } from 'app/area/links-section/links-section';
import { withRouter } from 'app/components/enhancers/with-router';
import { Case } from 'app/area/case';
import { CaseViewModal } from 'app/area/case/components/case-view-modal';
import { Outlet, useLocation, useOutletContext } from 'react-router-dom';
import { Draft } from 'app/area/case/draft';
import { useAiChatAssistantAccessInfo } from 'app/components/ai-chat-assistant/hooks/use-ai-chat-assistant-selectors';
import { SaveAsDraftInfoBanner } from 'ui/info-banner/info-banner';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { toDraft } from 'app/area/shared/route-urls';
import { escapeUrl } from 'app/components/favourite-layout/favourite/common/utils';
import styles from './startup.scss';

interface StartupComponentProps {
  params: { caseId?: string };
}

const CaseWithRouter = withRouter(Case);
const DraftWithRouter = withRouter(Draft);

type StartupProps = StartupState & DefaultContainerProps & StartupComponentProps;
const StartupComponent: React.FC<StartupProps> & { statePath?: string } = (props) => {
  React.useEffect(() => {
    scrollToTop();
  }, []);

  const { translation, sharedState, router } = props;  
  const { caseDraftCreation } = useAiChatAssistantAccessInfo() ?? {};
  const location = useLocation();
  const showSavedAsDraftInfo = (location.state as any)?.fromSaveAsDraft;
  const draftId = (location.state as any)?.draftId;
  const savedAsDraftUrl = toAbsoluteUrl(toDraft(draftId, ''), true);

  return (
    <>
      <div className="container main-grid">
        {showSavedAsDraftInfo && (
          <SaveAsDraftInfoBanner
            textTitle={translation.case_saved_as_draft}>
              <p>{translation.follow_up_draft}</p>
              <p><a href={escapeUrl(savedAsDraftUrl)}>{savedAsDraftUrl}</a></p>
              <p className={styles.saveAsDraftInfo}>{translation.save_as_draft_info}</p>
          </SaveAsDraftInfoBanner>          
        )}
        <NewCaseBanner
          textHeader={translation.new_case_header}
          textDescription={translation.new_case_description}
          textBtnRegisterNewCase={translation.new_case_register}
          textOpenCaseHeader={translation.open_case_header}
          textOpenCaseDescription={translation.open_case_description}
          textCaseNo={translation.open_case_case_no}
          textOpenCase={translation.open_case}
          textCaseDraftSubtitle={translation.case_draft_subtitle}
          textCaseDraftLinkCase={translation.case_draft_link_case}
          textCaseDraftLinkCases={translation.case_draft_link_cases}
          aiChatAssistant={!!caseDraftCreation}
        />
      </div>
      <LinksSection />
      {(!!sharedState.startupDashboardId || !!sharedState.startupDashboardTypeId) && (
        <div id="startup-dashboard">
          <Dashboard
            dashboardType={sharedState.startupDashboardTypeId}
            requestedMainFavouriteId={sharedState.startupDashboardId}
            mainFavouriteReadOnly={true}
            showDescription={false}
            location={router.location}
            hideFilters={true}
            hideFilterReplacements={true}
          />
          <Outlet context={{ renderCaseViewModal: true }} />
        </div>
      )}
    </>
  );
};

StartupComponent.statePath = STATE.startupArea;

const container = containerFactory(StartupComponent, undefined, null, startupTranslation);
export { container as Startup };

export const StartupDashboardCaseModalContainer = () => {
  const { renderCaseViewModal } = useOutletContext<{ renderCaseViewModal: boolean }>();
  return (
    renderCaseViewModal && <CaseViewModal>
      <Outlet />
    </CaseViewModal>
  );
};

export const StartupDashboardCaseView = () => {
  return (
    <CaseWithRouter />    
  );
};

export const StartupDashboardCaseDraft = () => {
  return (
    <DraftWithRouter />
  );
};
